import React from "react";
import "../styles/PolicyPages.css";

const SıkSorulanSorular = () => {
  return (
    <div className="policy-page">
      <h1>Sık Sorulan Sorular </h1>
      <p>
        Aşağıda, platformun kullanımı ve sahiplendirme süreciyle ilgili en sık
        sorulan soruların kısa ve net yanıtlarını bulabilirsiniz.
      </p>

      <h3>1. Hayvan sahiplenmek için ne yapmalıyım?</h3>
      <p>
        İlgilendiğiniz ilanın detay sayfasına girerek başvuru formunu
        doldurmanız yeterlidir. Başvurunuz, ilan sahibi veya yönetim tarafından
        değerlendirildikten sonra sizinle iletişime geçilir.
      </p>

      <h3>2. Başvurum ne kadar sürede sonuçlanır?</h3>
      <p>
        Süreç, ilan sahibinin dönüş hızına ve başvurunun incelenme durumuna göre
        değişebilir. Genel olarak başvurulara en geç 5 gün içinde dönüş
        yapılması beklenir.
      </p>

      <h3>3. Sahiplendirme ücretli mi?</h3>
      <p>
        Platform üzerinden yapılan sahiplendirmeler kural olarak ücretsizdir.
      </p>

      <h3>4. İlan verirken hangi bilgilere dikkat etmeliyim?</h3>
      <p>
        İlanda yer alan bilgilerin doğru, güncel ve hayvana ait olması gerekir.
        Yanıltıcı açıklamalar, sahte ilanlar veya eksik bilgi verilmesi halinde
        ilan kaldırılabilir ve hesap hakkında işlem yapılabilir.
      </p>

      <h3>5. İlan sahibine ne kadar sürede dönüş yapılır?</h3>
      <p>
        İlan sahibi, kendisine gelen başvurulara en geç 5 gün içinde dönüş
        yapmalıdır. Bu süre içinde dönüş yapılmaması halinde ilgili ilan yönetim
        tarafından silinebilir.
      </p>

      <h3>6. Başvuru yaptıktan sonra ne olur?</h3>
      <p>
        Başvurunuz sisteme düşer ve ilan sahibi tarafından değerlendirilir.
        Gerekli görülmesi halinde sizinle ek bilgi paylaşılması için iletişim
        kurulabilir.
      </p>

      <h3>7. Başvurum reddedilirse tekrar başvurabilir miyim?</h3>
      <p>
        Evet, yeni bir ilan için tekrar başvuru yapabilirsiniz. Ancak aynı ilan
        için yeniden başvuru yapmadan önce önceki değerlendirme sonucunu dikkate
        almanız önerilir.
      </p>

      <h3>8. Yanıltıcı başvuru veya sahte ilan durumunda ne olur?</h3>
      <p>
        Platformun işleyişini bozan, kullanıcıları yanıltan veya kötüye kullanım
        oluşturan başvurular ve ilanlar kaldırılabilir. Gerekli görülmesi
        halinde ilgili hesap askıya alınabilir veya silinebilir.
      </p>

      <h3>9. İletişime nasıl geçebilirim?</h3>
      <p>
        Site üzerindeki iletişim alanlarını veya e-posta adresini kullanarak
        bize ulaşabilirsiniz. Talebiniz en kısa sürede değerlendirilir.
      </p>

      <h3>10. Bu bilgiler güncellenebilir mi?</h3>
      <p>
        Evet. Platformun işleyişi, mevzuat veya kullanıcı ihtiyaçlarına göre bu
        bölüm zaman zaman güncellenebilir.
      </p>
    </div>
  );
};

export default SıkSorulanSorular;
